import { DEFAULT_API_CONFIG } from './apiConfig';
import { prepareData } from './orderReview.service';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/FieldManager`;
const baseAccountRoute = `${url}/account`;

export const getFieldManagers = async () => {
  const url = `${baseRoute}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getFieldManagerOptions = async () => {
  const url = `${baseRoute}/options`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getFieldManager = async id => {
  const url = `${baseRoute}/${id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getFieldManagerStateXRef = async () => {
  const url = `${baseRoute}/FieldManagerStateXRef`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

/**
 * POST
 */
export const createFieldManager = async user => {
  const url = `${baseRoute}`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(user),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

/**
 * PUT
 */
export const updateFieldManager = async (user, { syncAssignments = true } = {}) => {
  const query = queryString.stringify({ syncAssignments });
  const url = `${baseRoute}/${user.fieldManagerId}?${query}`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(user),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};
